import React from 'react';
import PropTypes from 'prop-types';

import ContextBlockItem from './components/ContextBlockItem';
import './style.scss';

const ContextBlocksList = ({ items, isDisabled }) => (
  <React.Fragment>
    <div styleName="title">CONTEXT BLOCKS</div>
    <div data-test="context-blocks" styleName="grid">
      {items.map(({ id, name, values }) => (
        <ContextBlockItem
          key={id}
          fields={Object.keys(values)}
          id={id}
          isDisabled={isDisabled}
          name={name}
        />
      ))}
    </div>
  </React.Fragment>
);

ContextBlocksList.propTypes = {
  isDisabled: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
};

ContextBlocksList.defaultProps = {
  items: [],
};

export default ContextBlocksList;
